export function verificarToken(token: any) {
  /* Verificacion del token en caso de ser nesesario */
  if (!token) return false;
  const tokenData = getTokenData(token);
  if (!tokenData || !tokenData.exp) return false;
  const fechaHoy = Date.now() / 1000;
  const fechaFinJWT = parseInt(tokenData.exp);
  if (fechaHoy < fechaFinJWT) {
    return true;
  } else {
    return false;
  }
}

export function getTokenData(token: any) {
  if (token) {
    const tokenData = token.split('.');
    const dataBody = decodificarBase64(tokenData[1]);
    return dataBody;
  } else {
    return null;
  }
}

export function decodificarBase64(data: String) {
  const dataBase64 = data.replace(/-/, '+').replace(/_/, '/');
  const dataString = atob(dataBase64);
  const json = JSON.parse(dataString);
  return json;
}
